import { WebsocketConfig } from './../configs/websocket.config';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SocketIdInterceptor implements HttpInterceptor {

  constructor(
    private websocketConfig: WebsocketConfig
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.websocketConfig?.socketId) {
      request = request.clone({
        setHeaders: {
          'X-Socket-ID': this.websocketConfig.socketId,
        },
      });
    }

    return next.handle(request);
  }
}
